import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Button, Modal, TimePicker, Input, Card, Form, Space, Grid, List, Row, Col, message } from "antd";
import dayjs from "dayjs";
import { supabase } from "../supabaseClient";
import StatusBadge from "../components/StatusBadge";
import { FilterBar } from "../components/FilterBar";
import { useLoading } from "../contexts/LoadingContext";


export default function AdminPage() {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  const [openEditProfile, setOpenEditProfile] = useState(false);
  const [form] = Form.useForm();

  // const [loading, setLoading] = useState(false);
  const { setLoading } = useLoading();
  const { confirm } = Modal;


  if (currentUser == null) {
    navigate("/login");
  }

  const { useBreakpoint } = Grid;

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [requests, setRequests] = useState([]);
  const [filters, setFilters] = useState({ date: null, status: null });

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  // Giờ quân nhân ra thăm
  const [gioRaTham, setGioRaTham] = useState(null);
  // Giờ quân nhân quay lại đơn vị
  const [gioVaoLaiDonVi, setGioVaoLaiDonVi] = useState(null);

  // const fetchData = useCallback(async (customFilters = filters) => {
  //   setLoading(true);
  //   let query = supabase
  //     .from("don_tham_quan_nhan")
  //     .select("*")
  //     .order("created_at", { ascending: false });

  //   if (customFilters.date) {
  //     query = query.eq("ngay_tham", customFilters.date.format("YYYY-MM-DD"));
  //   }

  //   if (customFilters.status) {
  //     query = query.eq("status", customFilters.status);
  //   }

  //   if (customFilters.name) {
  //     // nếu muốn tìm gần đúng thì dùng ilike (case-insensitive)
  //     query = query.ilike("ten_quan_nhan", `%${customFilters.name}%`);
  //   }

  //   if (customFilters.don_vi) {
  //     // nếu muốn tìm gần đúng thì dùng ilike (case-insensitive)
  //     query = query.ilike("don_vi", `%${customFilters.don_vi}%`);
  //   }

  //   const { data } = await query;
  //   setRequests(data || []);
  //   setLoading(false);
  // }, [filters, setLoading]);

  const fetchData = useCallback(async (customFilters) => {
  setLoading(true);
  let query = supabase
    .from("don_tham_quan_nhan")
    .select("*")
    .order("created_at", { ascending: false });

  if (customFilters?.date) {
    query = query.eq("ngay_tham", customFilters.date.format("YYYY-MM-DD"));
  }

  if (customFilters?.status) {
    query = query.eq("status", customFilters.status);
  }

  if (customFilters?.name) {
    query = query.ilike("ten_quan_nhan", `%${customFilters.name}%`);
  }

  if (customFilters?.don_vi) {
    query = query.ilike("don_vi", `%${customFilters.don_vi}%`);
  }

  const { data } = await query;
  setRequests(data || []);
  setLoading(false);
}, [setLoading]); // bỏ filters khỏi dependency

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const handleApproveOrUpdate = async () => {
    if (!gioRaTham || !gioVaoLaiDonVi) {
      message.error("Vui lòng chọn đầy đủ giờ ra thăm và giờ vào lại đơn vị");
      return;
    }

    if (gioVaoLaiDonVi.isBefore(gioRaTham)) {
      message.error("Giờ vào lại đơn vị phải sau giờ ra thăm");
      return;
    }
    setLoading(true);
    const ngay = dayjs(selected.ngay_tham).format("YYYY-MM-DD");

    const payload = {
      gio_ra_tham: `${ngay} ${gioRaTham.format("HH:mm")}:00`,
      gio_vao_lai_don_vi: `${ngay} ${gioVaoLaiDonVi.format("HH:mm")}:00`,
      approved_by: currentUser.id, // user đang login
      approved_at: new Date().toISOString(),
    };

    let mailStatus = "";

    // ✅ TRƯỜNG HỢP 1: CHỜ DUYỆT → DUYỆT
    if (selected.status === "cho_duyet") {
      payload.status = "da_duyet";
      mailStatus = "da_duyet";
    }

    // ✅ TRƯỜNG HỢP 2: ĐÃ DUYỆT → CHỈ SỬA GIỜ
    if (selected.status === "da_duyet") {
      mailStatus = "cap_nhat_gio";
    }

    // // ⛔ Không cho thao tác nếu đã hủy
    // if (selected.status === "huy") {
    //   message.warning("Đơn đã hủy không thể chỉnh sửa");
    //   return;
    // }

    const { error } = await supabase
      .from("don_tham_quan_nhan")
      .update(payload)
      .eq("id", selected.id);

    payload.admin_full_name = currentUser.full_name;
    payload.admin_phone = currentUser.phone;
    payload.admin_don_vi = currentUser.don_vi;

    if (!error) {
      await sendMail(
        {
          ...selected,
          gio_ra_tham: payload.gio_ra_tham,
          gio_vao_lai_don_vi: payload.gio_vao_lai_don_vi,
        },
        mailStatus
      );

      message.success(
        selected.status === "cho_duyet"
          ? "Đã duyệt đơn và thông báo cho quân nhân"
          : "Đã cập nhật giờ và thông báo cho quân nhân"
      );

      setOpen(false);
      setSelected(null);
      setGioRaTham(null);
      setGioVaoLaiDonVi(null);
      fetchData(filters);
    }
    setLoading(false);
  };

  const handleUpdateProfile = async (values) => {
    // const currentUser = JSON.parse(localStorage.getItem("user"));

    const payload = {
      full_name: values.full_name,
      phone: values.phone,
    };

    // Nếu nhập mật khẩu thì update
    if (values.password) {
      payload.password = values.password;
    }

    const { error } = await supabase
      .from("users")
      .update(payload)
      .eq("id", currentUser.id)

    if (error) {
      message.error("Cập nhật thất bại");
      console.error(error);
      return;
    }

    // Update localStorage user
    const updatedUser = { ...currentUser, ...payload };
    localStorage.setItem("currentUser", JSON.stringify(updatedUser));

    message.success("Cập nhật thành công");

    setOpenEditProfile(false);
  };

  const handleReject = async (id) => {
    setLoading(true);
    await supabase
      .from("don_tham_quan_nhan")
      .update(
        {
          status: "huy",
          approved_by: currentUser.id, // user đang login
          approved_at: new Date().toISOString(),
        }
      )
      .eq("id", id);
    const record = requests.find((d) => d.id === id);
    record.admin_full_name = currentUser.full_name;
    record.admin_phone = currentUser.phone;
    record.admin_don_vi = currentUser.don_vi;
    await sendMail(record, "huy");
    message.success("Đã hủy đơn");
    fetchData(filters);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    confirm({
      title: "Xác nhận xóa",
      content: "Bạn có chắc chắn muốn xóa đơn này không?",
      okText: "Xóa",
      okType: "danger",
      cancelText: "Hủy",
      async onOk() {
        const { error } = await supabase
          .from("don_tham_quan_nhan")
          .delete()
          .eq("id", id);

        if (error) {
          message.error("Xóa thất bại");
          console.error(error);
        } else {
          message.success("Đã xóa đơn");
          fetchData(); // load lại bảng
        }
      },
    });
  };

  const confirmDeleteAll = () => {
    Modal.confirm({
      title: "Xóa tất cả đơn?",
      content: "Hành động này KHÔNG thể hoàn tác!",
      okText: "Xóa tất cả",
      okType: "danger",
      cancelText: "Hủy",
      onOk: deleteAllRequests,
    });
  };

  const deleteAllRequests = async () => {
    try {
      const { error } = await supabase
        .from("don_tham_quan_nhan")
        .delete()
        .not("id", "is", null);

      if (error) {
        message.error("Xóa thất bại");
        console.error(error);
      } else {
        message.success("Đã xóa toàn bộ đơn");
        fetchData(); // reload danh sách
      }
    } catch (err) {
      console.error(err);
      message.error("Có lỗi xảy ra");
    }
  };
  const sendMail = async (record, status) => {
    await supabase.functions.invoke("send-notification-mail", {
      body: {
        email: record.email_nhan_ket_qua,
        ten_quan_nhan: record.ten_quan_nhan,
        status,
        ngay_tham: dayjs(record.ngay_tham).format("DD/MM/YYYY"),
        gio_ra_tham: record.gio_ra_tham
          ? dayjs(record.gio_ra_tham).format("HH:mm")
          : "",
        gio_vao_lai_don_vi: record.gio_vao_lai_don_vi
          ? dayjs(record.gio_vao_lai_don_vi).format("HH:mm")
          : "",
        admin_name: record.admin_full_name,
        admin_phone: record.admin_phone,
        admin_don_vi: record.admin_don_vi,
      },
    });
  };

  const columns = [
    { title: "Quân nhân", dataIndex: "ten_quan_nhan" },
    { title: "Đơn vị", dataIndex: "don_vi" },
    { title: "Người thân", dataIndex: "ten_nguoi_than" },
    { title: "Số điện thoại", dataIndex: "so_dien_thoai" },
    {
      title: "Ngày thăm",
      dataIndex: "ngay_tham",
      render: (v) => dayjs(v).format("DD/MM/YYYY"),
    },
    {
      title: "Giờ ra thăm",
      dataIndex: "gio_ra_tham",
      render: (v) => (v ? dayjs(v).format("HH:mm") : "--"),
    },
    {
      title: "Giờ vào lại đơn vị",
      dataIndex: "gio_vao_lai_don_vi",
      render: (v) => (v ? dayjs(v).format("HH:mm") : "--"),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (status) => <StatusBadge status={status} />,
    },
    {
      title: "Hành động",
      render: (_, record) => {
        const isPastDate = dayjs(record.ngay_tham).isBefore(dayjs(), "day");

        return (
          <Space direction="vertical" size={8}>
            <Button
              danger
              size="small"
              onClick={() => handleDelete(record.id)}
            >
              Xóa
            </Button>
            {record.status === "cho_duyet" && (
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setSelected(record);
                    setOpen(true);
                  }}
                >
                  Duyệt
                </Button>
                <Button danger onClick={() => handleReject(record.id)}>
                  Hủy
                </Button>
              </>
            )}

            {record.status === "da_duyet" && (
              <>
                <Button
                  type="default"
                  disabled={isPastDate}
                  onClick={() => {
                    setSelected(record);
                    setGioRaTham(dayjs(record.gio_ra_tham));
                    setGioVaoLaiDonVi(dayjs(record.gio_vao_lai_don_vi));
                    setOpen(true);
                  }}
                >
                  Sửa giờ
                </Button>
                <Button
                  danger
                  disabled={isPastDate}
                  onClick={() => handleReject(record.id)}
                >
                  Hủy
                </Button>
              </>
            )}

            {record.status === "huy" && (
              <Button danger disabled>
                Hủy
              </Button>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <Card title="QUẢN LÝ ĐĂNG KÝ THĂM QUÂN NHÂN">

      <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
        {/* Filter */}
        <Col xs={24} md={18}>
          <FilterBar
            filters={filters}
            setFilters={setFilters}
            onFilter={fetchData}
          />
        </Col>

        {/* Nút cập nhật thông tin */}
        <Col xs={24} md={6} style={
          isMobile
            ? {} // mobile: giữ nguyên
            : { display: "flex", justifyContent: "flex-end" } // desktop: căn phải
        }
        >
          <Button
            type="primary"
            block
            style={{ backgroundColor: "green", borderRadius: 6, width: "200px", marginRight: "3px" }}
            onClick={() => {
              form.setFieldsValue({
                full_name: currentUser.full_name,
                phone: currentUser.phone,
                password: "",
              });
              setOpenEditProfile(true);
            }}
          >
            Cập nhật thông tin cá nhân
          </Button>
          <Button
            danger
            onClick={() => confirmDeleteAll()}
          >
            Xóa tất cả đơn
          </Button>
        </Col>
      </Row>

      {!isMobile ? (
        <Table
          rowKey="id"
          columns={columns}
          dataSource={requests}
          rowClassName={(record) => `row-${record.status}`}
          pagination={{
            pageSize: 12,
          }}
        />
      ) : (
        <List
          dataSource={requests}
          pagination={{ pageSize: 12 }}
          renderItem={(item) => {
            const isPastDate = dayjs(item.ngay_tham).isBefore(dayjs(), "day");

            return (
              <Card style={{
                marginBottom: 12, backgroundColor: "#f9f9f9", border: "1px solid #e0e0e0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}>
                <p><b>Quân nhân:</b> {item.ten_quan_nhan}</p>
                <p><b>Đơn vị:</b> {item.don_vi}</p>
                <p><b>Người thân:</b> {item.ten_nguoi_than}</p>
                <p><b>Số điện thoại:</b> {item.so_dien_thoai}</p>
                <p><b>Ngày:</b> {item.ngay_tham}</p>
                <p>
                  <b>Giờ ra thăm:</b>{" "}
                  {item.gio_ra_tham ? dayjs(item.gio_ra_tham).format("HH:mm") : "--"}
                </p>
                <p>
                  <b>Giờ vào lại đơn vị:</b>{" "}
                  {item.gio_vao_lai_don_vi ? dayjs(item.gio_vao_lai_don_vi).format("HH:mm") : "--"}
                </p>

                <p style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <b>Trạng thái:</b>
                  <StatusBadge status={item.status} />
                </p>

                <Space wrap>
                  {item.status === "cho_duyet" && (
                    <>
                      <Button
                        size="small"
                        type="primary"
                        onClick={() => {
                          setSelected(item);
                          setOpen(true);
                        }}
                      >
                        Duyệt
                      </Button>
                      <Button
                        size="small"
                        danger
                        onClick={() => handleReject(item.id)}
                      >
                        Hủy
                      </Button>
                    </>
                  )}

                  {item.status === "da_duyet" && (
                    <>
                      <Button
                        size="small"
                        disabled={isPastDate}
                        onClick={() => {
                          setSelected(item);
                          setGioRaTham(dayjs(item.gio_ra_tham));
                          setGioVaoLaiDonVi(dayjs(item.gio_vao_lai_don_vi));
                          setOpen(true);
                        }}
                      >
                        Sửa giờ
                      </Button>
                      <Button
                        size="small"
                        danger
                        disabled={isPastDate}
                        onClick={() => handleReject(item.id)}
                      >
                        Hủy
                      </Button>
                    </>
                  )}

                  {item.status === "huy" && (
                    <Button size="small" danger disabled>
                      Hủy
                    </Button>
                  )}
                  <Button
                    danger
                    size="small"
                    onClick={() => handleDelete(item.id)}
                  >
                    Xóa
                  </Button>

                </Space>
              </Card>
            );
          }}
        />
      )}


      <Modal
        title="Chỉ định thời gian ra/vào cho quân nhân"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={handleApproveOrUpdate}
      >
        <p>
          <b>Ngày thăm:</b> {selected && dayjs(selected.ngay_tham).format("DD/MM/YYYY")}
        </p>
        <p>Giờ quân nhân ra thăm</p>
        <TimePicker format="HH:mm" style={{ width: "100%" }} value={gioRaTham} onChange={setGioRaTham} />

        <p style={{ marginTop: 12 }}>Giờ quân nhân vào lại đơn vị</p>
        <TimePicker
          format="HH:mm"
          style={{ width: "100%" }}
          value={gioVaoLaiDonVi}
          onChange={setGioVaoLaiDonVi}
        />
      </Modal>

      <Modal
        title="Cập nhật thông tin admin"
        open={openEditProfile}
        onCancel={() => setOpenEditProfile(false)}
        onOk={() => form.submit()}
        okText="Lưu"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleUpdateProfile}
        // onFinish={async (values) => {
        //   setLoading(true);
        //   const payload = {
        //     full_name: values.full_name,
        //     phone: values.phone,
        //   };

        //   // chỉ đổi mật khẩu nếu nhập
        //   if (values.password) {
        //     payload.password = values.password;
        //   }

        //   const { error } = await supabase
        //     .from("users")
        //     .update(payload)
        //     .eq("id", currentUser.id);

        //   if (error) {
        //     message.error("Cập nhật thất bại");
        //     return;
        //   }

        //   // cập nhật localStorage
        //   const updatedUser = {
        //     ...currentUser,
        //     full_name: values.full_name,
        //     phone: values.phone,
        //   };
        //   localStorage.setItem("currentUser", JSON.stringify(updatedUser));

        //   message.success("Đã cập nhật thông tin");
        //   setLoading(false);
        //   setOpenEditProfile(false);
        // }}
        >
          <Form.Item
            label="Họ và tên"
            name="full_name"
            rules={[{ required: true, message: "Nhập họ và tên" }]}
          >
            <Input placeholder="VD: Nguyễn Văn A" />
          </Form.Item>

          <Form.Item
            label="Số điện thoại liên hệ"
            name="phone"
            rules={[
              { required: true, message: "Nhập số điện thoại" },
              { pattern: /^[0-9]{9,11}$/, message: "Số điện thoại không hợp lệ" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Mật khẩu mới"
            name="password"
            extra="Để trống nếu không đổi mật khẩu"
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}
